const SCROLL_ANIMATION_TRIGGER_CLASSNAME = 'scroll-trigger';
const SCROLL_ANIMATION_OFFSCREEN_CLASSNAME = 'scroll-trigger--offscreen';
const SCROLL_ZOOM_IN_TRIGGER_CLASSNAME = 'animate--zoom-in';
const SCROLL_ANIMATION_CANCEL_CLASSNAME = 'scroll-trigger--cancel';

// Scroll in animation logic
function onIntersection(elements, observer) {
  elements.forEach((element, index) => {
    if (element.isIntersecting) {
      const elementTarget = element.target;
      if (elementTarget.classList.contains(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME)) {
        elementTarget.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
        if (elementTarget.hasAttribute('data-cascade'))
          elementTarget.setAttribute('style', `--animation-order: ${index};`);
      }
      observer.unobserve(elementTarget);
    } else {
      element.target.classList.add(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
      element.target.classList.remove(SCROLL_ANIMATION_CANCEL_CLASSNAME);
    }
  });
}

function initializeScrollAnimationTrigger(rootEl = document, isDesignModeEvent = false) {
  const animationTriggerElements = Array.from(rootEl.getElementsByClassName(SCROLL_ANIMATION_TRIGGER_CLASSNAME));
  if (animationTriggerElements.length === 0) return;

  if (isDesignModeEvent) {
    animationTriggerElements.forEach((element) => {
      element.classList.add('scroll-trigger--design-mode');
    });
    return;
  }

  const observer = new IntersectionObserver(onIntersection, {
    rootMargin: '0px 0px -50px 0px',
  });
  animationTriggerElements.forEach((element) => observer.observe(element));
}

// Zoom in animation logic
function initializeScrollZoomAnimationTrigger() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const animationTriggerElements = Array.from(document.getElementsByClassName(SCROLL_ZOOM_IN_TRIGGER_CLASSNAME));

  if (animationTriggerElements.length === 0) return;

  const scaleAmount = 0.2 / 100;

  animationTriggerElements.forEach((element) => {
    let elementIsVisible = false;
    const observer = new IntersectionObserver((elements) => {
      elements.forEach((entry) => {
        elementIsVisible = entry.isIntersecting;
      });
    });
    observer.observe(element);

    element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));

    window.addEventListener(
      'scroll',
      throttle(() => {
        if (!elementIsVisible) return;

        element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));
      }),
      { passive: true }
    );
  });
}

function percentageSeen(element) {
  const viewportHeight = window.innerHeight;
  const scrollY = window.scrollY;
  const elementPositionY = element.getBoundingClientRect().top + scrollY;
  const elementHeight = element.offsetHeight;

  if (elementPositionY > scrollY + viewportHeight) {
    // If we haven't reached the image yet
    return 0;
  } else if (elementPositionY + elementHeight < scrollY) {
    // If we've completely scrolled past the image
    return 100;
  }

  // When the image is in the viewport
  const distance = scrollY + viewportHeight - elementPositionY;
  let percentage = distance / ((viewportHeight + elementHeight) / 100);
  return Math.round(percentage);
}

window.addEventListener('DOMContentLoaded', () => {
  initializeScrollAnimationTrigger();
  initializeScrollZoomAnimationTrigger();
});

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => initializeScrollAnimationTrigger(event.target, true));
  document.addEventListener('shopify:section:reorder', () => initializeScrollAnimationTrigger(document, true));
}

/* ===== Apparition des produits : « dévoilement » (rideau + zoom doux) ===== */
(function () {
  if (window.__lecReveal) return;
  window.__lecReveal = true;

  var css = [
    '.lec-host.scroll-trigger, .lec-host.scroll-trigger.animate--slide-in { opacity: 1 !important; transform: none !important; animation: none !important; }',
    '.lec-reveal { opacity: 0; transform: translateY(2.8rem); }',
    '.lec-reveal.lec-in { opacity: 1; transform: none; animation: lecCardIn 0.9s cubic-bezier(0.22, 1, 0.36, 1) var(--lec-d, 0ms) backwards; }',
    '.lec-reveal .card__media, .lec-reveal .product-image-container { clip-path: inset(0 0 100% 0); }',
    '.lec-reveal.lec-in .card__media, .lec-reveal.lec-in .product-image-container { clip-path: none; animation: lecUnveil 1.1s cubic-bezier(0.77, 0, 0.18, 1) var(--lec-d, 0ms) backwards; }',
    '.lec-reveal .card__media img, .lec-reveal .product-image-container img { transform: scale(1.18); }',
    '.lec-reveal.lec-in .card__media img, .lec-reveal.lec-in .product-image-container img { transform: none; animation: lecZoom 1.6s cubic-bezier(0.22, 1, 0.36, 1) var(--lec-d, 0ms) backwards; }',
    '@keyframes lecCardIn { from { opacity: 0; transform: translateY(2.8rem); } to { opacity: 1; transform: none; } }',
    '@keyframes lecUnveil { from { clip-path: inset(0 0 100% 0); } to { clip-path: inset(0 0 0 0); } }',
    '@keyframes lecZoom { from { transform: scale(1.18); } to { transform: scale(1); } }'
  ].join('\n');

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;

  var style = document.createElement('style');
  style.id = 'lec-reveal-style';
  style.textContent = css;
  document.head.appendChild(style);

  var SEL = '.product-card-wrapper, .product-card';

  var io = new IntersectionObserver(function (entries) {
    var visible = entries
      .filter(function (e) { return e.isIntersecting; })
      .map(function (e) { return e.target; })
      .sort(function (a, b) {
        var ra = a.getBoundingClientRect();
        var rb = b.getBoundingClientRect();
        return Math.round(ra.top - rb.top) || ra.left - rb.left;
      });
    visible.forEach(function (el, i) {
      el.style.setProperty('--lec-d', Math.min(i, 8) * 110 + 'ms');
      el.classList.add('lec-in');
      io.unobserve(el);
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

  var seen = new WeakSet();

  function prepEl(el) {
    if (seen.has(el)) return;
    if (el.closest('holo-carousel')) return;
    if (el.parentElement && el.parentElement.closest('.product-card-wrapper, .product-card')) return;
    seen.add(el);
    var host = el.closest('.scroll-trigger');
    if (host) host.classList.add('lec-host');
    el.classList.add('lec-reveal');
    io.observe(el);
  }

  function prep(root) {
    if (!root || root.nodeType !== 1 && root !== document) return;
    if (root.matches && root.matches(SEL)) prepEl(root);
    root.querySelectorAll(SEL).forEach(prepEl);
  }

  function start() {
    prep(document);
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (n) { if (n.nodeType === 1) prep(n); });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
